import { Home, ScanLine, History, Library, LogIn, User } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { useUserRole } from "@/hooks/useUserRole";
import customIcon from "@/assets/icon.jpg";

const BottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { isPro } = useUserRole(user?.id);

  const navItems = [
    { icon: Home, label: "Home", path: "/" },
    { icon: ScanLine, label: "Scan", path: "/scan" },
    { icon: Library, label: "Library", path: "/library" },
    { icon: isPro ? User : "custom", label: isPro ? "Account" : "Pro", path: "/pricing" },
  ];

  // Add auth button if not logged in
  if (!user) {
    navItems.push({ icon: LogIn, label: "Sign In", path: "/auth" });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border">
      <div className="flex justify-around items-center h-16 max-w-md mx-auto px-2">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-xl transition-all",
                isActive 
                  ? "text-foreground scale-105" 
                  : "text-muted-foreground hover:text-foreground hover:scale-105"
              )}
            >
              {Icon === "custom" ? (
                <img 
                  src={customIcon} 
                  alt="FactScan Pro plan icon" 
                  className={cn(
                    "w-5 h-5 transition-all",
                    isActive && "drop-shadow-glow"
                  )} 
                />
              ) : (
                <Icon className={cn(
                  "w-5 h-5 transition-all",
                  isActive && "drop-shadow-glow"
                )} />
              )}
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
